export const hasXTP = ({ permissions: { products = {} } = {} }) => products.xtp
